/** Desktop mid breakpoint (Bootstrap md). At or above → desktop modes. */
export const DESKTOP_MIN_WIDTH = 768;

/**
 * Initial presentation mode from viewport width.
 * @param {number} width
 * @returns {'expanded'|'icons'|'drawerClosed'|'drawerOpen'}
 */
export function modeOnLoad(width) {
  return width >= DESKTOP_MIN_WIDTH ? 'expanded' : 'drawerClosed';
}

/**
 * Flip presentation mode within the current viewport family.
 * @param {'expanded'|'icons'|'drawerClosed'|'drawerOpen'} mode
 * @returns {'expanded'|'icons'|'drawerClosed'|'drawerOpen'}
 */
export function togglePresentationMode(mode) {
  switch (mode) {
    case 'expanded':
      return 'icons';
    case 'icons':
      return 'expanded';
    case 'drawerClosed':
      return 'drawerOpen';
    case 'drawerOpen':
      return 'drawerClosed';
    default:
      throw new Error(`Unknown presentation mode: ${mode}`);
  }
}

/**
 * Crossing the breakpoint reapplies the load rule for that side.
 * @param {number} width
 * @returns {'expanded'|'icons'|'drawerClosed'|'drawerOpen'}
 */
export function modeOnResize(width) {
  return modeOnLoad(width);
}

/**
 * Whether the sidebar DOM should carry the SB Admin `toggled` class.
 * `icons` and `drawerClosed` share that class; CSS distinguishes by viewport.
 * @param {'expanded'|'icons'|'drawerClosed'|'drawerOpen'} mode
 * @returns {boolean}
 */
export function isSidebarToggled(mode) {
  return mode === 'icons' || mode === 'drawerClosed';
}

/**
 * Desktop presentation family (`expanded` / `icons`) vs mobile drawer family.
 * @param {'expanded'|'icons'|'drawerClosed'|'drawerOpen'} mode
 * @returns {boolean}
 */
export function isDesktopPresentation(mode) {
  return mode === 'expanded' || mode === 'icons';
}
